import { render, staticRenderFns } from "./PantauIB.vue?vue&type=template&id=81067774"
import script from "./PantauIB.vue?vue&type=script&lang=js"
export * from "./PantauIB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports